import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment'
import NumberFormat from 'react-number-format';

import Header from '../../../component/common/UnitLeaveHeader';
import Loader from '../../../component/common/Loader';
import ModalWindow from '../../../component/common/ModalWindow';
import TermsAndConditions from '../../../component/leave/TermsAndConditions';
import Shimmer from '../../../component/common/Shimmer';

import CONSTANT from '../../../constant';
import { onChange, setOptions, validateForm, getStorage, setError, setRequired } from '../../../utils';
import { getLeaveType, getHolidayListForYear, getAddressType } from '../../../actions/MasterAction';
// import { applyLeaves, getLeaveSummary, getLeavesList } from '../../../actions/LeaveAction';
import { getUserProxyLeaveDetail, addLeaveDetail } from '../../../actions/UnitLeaveAction';
import { getUnitUserSummary } from '../../../actions/UserAction';


class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const assignedToOptions = getStorage(CONSTANT.cookie.recipients).sort(this.onCompare);
        this.state = {
            userCode: { name: 'userCode', value: '', error: '', isRequired: true, options: [] },
            assignedTo: { name: 'assignedTo', value: '', error: '', isRequired: true, options: assignedToOptions },
            leaveTypeId: { name: 'leaveTypeId', value: '', options: [], error: '', isRequired: true },
            startDate: { name: 'startDate', value: moment().format('YYYY-MM-DD'), error: '', isRequired: true },
            endDate: { name: 'endDate', value: moment().format('YYYY-MM-DD'), error: '', isRequired: true },
            noOfDays: { name: 'noOfDays', value: '', error: '', isRequired: true },
            duration: { name: 'duration', value: '', error: '', isRequired: false, options: CONSTANT.static.leaveDuration },
            addressTypeId: { name: 'addressTypeId', value: '', options: [], error: '', isRequired: true },
            remoteAddress: { name: 'remoteAddress', value: '', error: '', isRequired: false },
            reason: { name: 'reason', value: '', error: '', isRequired: true },

            leaveList: undefined,
            userSummary: undefined,
            holidays: undefined,
            leaveSummary: undefined,

            showLoader: false,
            showModal: false,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.leave;
        const dt = new Date();

        getLeaveType().then((res: any) => {
            const filtered = res.result.filter((i: any) => i.code !== CONSTANT.static.leaveType.nonel).map((i: any) => {
                if (i.code === CONSTANT.static.leaveType.el) {
                    i.name = 'Earned Leave';
                }
                return i;
            });
            setOptions(this, this.state.leaveTypeId.name, filtered);
        });
        getHolidayListForYear(dt.getFullYear()).then((res: any) => {
            this.setState({ holidays: res.result });
        })
        getAddressType().then((res: any) => {
            setOptions(this, this.state.addressTypeId.name, res.result);
        });
        getUnitUserSummary().then((res: any) => {
            setOptions(this, this.state.userCode.name, res.result);
        });

        // need to show the modal window on load
        this.onShowModal();
    }

    render() {
        const { userCode, assignedTo, addressTypeId, remoteAddress, reason, userSummary } = this.state;
        const { duration, startDate, endDate, noOfDays, leaveTypeId, holidays, leaveSummary, showLoader, showModal } = this.state;
        const showDuration = this.showDuration();
        const { weekends: we, holidays: hd } = this.calculateNumberOfDays();

        let message = '';
        if (we.length !== 0 && hd.length !== 0) {
            const commArr = [...we, ...hd];
            message = `Intervening ${we.length} Weekly off(s) and ${hd.length} Holiday(s). Dated: ${commArr.map((i: any) => moment(i.date).format('DD MMM YYYY')).join(', ')}`;
        } else if (we.length !== 0 && hd.length === 0) {
            message = `Intervening ${we.length} Weekly off(s) Dated: ${we.map((i: any) => moment(i.date).format('DD MMM YYYY')).join(', ')}`;
        } else if (we.length === 0 && hd.length !== 0) {
            message = `Intervening ${we.length} Holiday(s). Dated: ${hd.map((i: any) => moment(i.date).format('DD MMM YYYY')).join(', ')}`;
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row my-3">
                            <div className="col-md-8">
                                <h1 className="page-title">Leave Application Form</h1>
                            </div>
                            <div className="col-md-4">
                                <Link to={CONSTANT.component.unitProxyLeaveList.url} className="btn btn-sm btn-link float-right">Go Back</Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Employee for whom you want to raise the leave request<small>*</small></label>
                                                    <select
                                                        value={userCode.value}
                                                        className={userCode.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                        onChange={this.onChange}
                                                        name={userCode.name}>
                                                        <option value="">Select an Employee</option>
                                                        {
                                                            userCode.options.map((item: any, index: number) => {
                                                                return <option key={index} value={item.code}>{item.name} ({item.employeeNumber})</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div>
                                            {
                                                userCode.value !== "" && <React.Fragment>

                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Send this application to <small>*</small></label>
                                                            <select
                                                                value={assignedTo.value}
                                                                className={assignedTo.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                onChange={this.onChange}
                                                                name={assignedTo.name}>
                                                                <option value="">Select an Employee</option>
                                                                {
                                                                    assignedTo.options.map((item: any, index: number) => {
                                                                        return <option key={index} value={item.code}>{item.name} ({item.employeeNumber})</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Leave type <small>*</small></label>
                                                            <select
                                                                value={leaveTypeId.value}
                                                                className={leaveTypeId.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                onChange={this.onChange}
                                                                name={leaveTypeId.name}>
                                                                <option value="">Select a leave type</option>
                                                                {
                                                                    leaveTypeId.options.map((item: any, index: number) => {
                                                                        return <option key={index} value={item.code}>{item.name}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className={showDuration ? "col-md-3" : "col-md-4"}>
                                                        <div className="form-group">
                                                            <label>From Date</label>
                                                            <input
                                                                type="date"
                                                                className={startDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder="Name of the employee"
                                                                name={startDate.name}
                                                                value={startDate.value}
                                                                min={moment().subtract(30, 'day').format('YYYY-MM-DD')}
                                                                max={moment().add(30, 'day').format('YYYY-MM-DD')}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={showDuration ? "col-md-3" : "col-md-4"}>
                                                        <div className="form-group">
                                                            <label>To Date </label>
                                                            <input
                                                                type="date"
                                                                className={endDate.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder=""
                                                                name={endDate.name}
                                                                value={endDate.value}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className={showDuration ? "col-md-3" : "col-md-4"}>
                                                        <div className="form-group">
                                                            <label># of Days </label>
                                                            <NumberFormat
                                                                readOnly={true}
                                                                maxLength={5}
                                                                allowNegative={false}
                                                                type="text"
                                                                className={noOfDays.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder="Number of Days"
                                                                name={noOfDays.name}
                                                                value={noOfDays.value}
                                                                onChange={this.onChange}
                                                            />

                                                        </div>
                                                    </div>
                                                    {
                                                        showDuration && <div className="col-md-3">
                                                            <div className="form-group">
                                                                <label>Duration *</label>
                                                                <select
                                                                    className={duration.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                    placeholder="Name of the employee"
                                                                    name={duration.name}
                                                                    onChange={this.onChange}
                                                                    value={duration.value}>
                                                                    <option value="">Select duration</option>
                                                                    {
                                                                        duration.options.map((item: any, index: number) => {
                                                                            return <option key={index} value={item.code}>{item.name}</option>
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    }
                                                    {
                                                        message.length > 0 && <div className="col-md-12 mb-3"><small>{message}</small></div>
                                                    }
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Address <small>*</small></label>
                                                            <select
                                                                value={addressTypeId.value}
                                                                className={addressTypeId.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                onChange={this.onChange}
                                                                name={addressTypeId.name}>
                                                                <option value="">Select Address type</option>
                                                                {
                                                                    addressTypeId.options.map((item: any, index: number) => {
                                                                        return <option key={index} value={item.code}>{item.name}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {
                                                        addressTypeId.value === "2" && <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Address when leaving head quarter<small>*</small> </label>
                                                                <input
                                                                    type="text"
                                                                    className={remoteAddress.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                    placeholder="Enter address"
                                                                    name={remoteAddress.name}
                                                                    value={remoteAddress.value}
                                                                    onChange={this.onChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label>Reason of Leave <small>*</small> </label>
                                                            <textarea
                                                                rows={2}
                                                                maxLength={50}
                                                                className={reason.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                                                placeholder="Type your message..."
                                                                name={reason.name}
                                                                value={reason.value}
                                                                onChange={this.onChange}
                                                            />
                                                        </div>
                                                    </div>

                                                </React.Fragment>
                                            }

                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-md-3">
                                                <Link to={CONSTANT.component.userLeaveList.url} className="btn btn-block cancel-button btn-sm btn-sm">Cancel</Link>
                                            </div>
                                            <div className="col-md-6">
                                                &nbsp;
                                            </div>
                                            <div className="col-md-3">
                                                <button type="submit" onClick={this.onSubmit} className="btn btn-block submit-button btn-sm">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-3">
                                {
                                    userSummary !== undefined && <div className="card mb-3">
                                        <div className="card-header">
                                            Weekly Off
                                    </div>
                                        <div className="card-body">
                                            <ul className="pl-3 mb-0">
                                                {
                                                    userSummary !== undefined && userSummary.weeklyOff !== undefined && userSummary.weeklyOff.split(',').map((i: any, index: any) => {
                                                        const obj = CONSTANT.static.daysOfWeek.filter((j: any) => j.code === parseFloat(i))[0];
                                                        return <li key={index}>
                                                            {obj.name}
                                                        </li>
                                                    })
                                                }

                                            </ul>
                                            {
                                                userSummary !== undefined && (userSummary.weeklyOff === undefined || userSummary.weeklyOff.length === 0) && <div>Couldnt find any weekly offs for you</div>
                                            }
                                            {
                                                userSummary === undefined && <Shimmer />
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    leaveSummary !== undefined && <div className="card mb-3">
                                        <div className="card-header">
                                            Leaves Balance
                                    </div>
                                        <div className="card-body">
                                            <ul className="pl-3 mb-0">
                                                {
                                                    leaveSummary !== undefined && leaveSummary.filter((item: any) => item.code !== CONSTANT.static.leaveType.cml).map((i: any, index: any) => {
                                                        const balance = i.total - i.used - i.pending;
                                                        const isNumber = balance % 1 === 0;
                                                        return <li key={index}>
                                                            <span className="mr-1">{i.name}</span>-<strong className="mx-1">{isNumber ? balance : balance.toFixed(2)}</strong> Day(s)
                                                    </li>
                                                    })
                                                }
                                            </ul>
                                            {
                                                leaveSummary === undefined && <Shimmer />
                                            }
                                        </div>
                                    </div>
                                }
                                <div className="card">
                                    <div className="card-header">
                                        Holidays in {new Date().getFullYear()}
                                    </div>
                                    <div className="card-body">
                                        <ul className="pl-3 mb-0">
                                            {
                                                holidays !== undefined && holidays.map((i: any, index: number) => {
                                                    return <li key={index}>
                                                        {`${moment(i.date).format("DD MMM ")} - ${i.name} `}
                                                    </li>
                                                })
                                            }
                                        </ul>
                                        {
                                            holidays === undefined && <Shimmer />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
                {
                    showModal && <ModalWindow
                        title="General Conditions"
                        backdrop={false}
                        toggleModal={this.onCancel}>
                        <TermsAndConditions
                            onSubmit={this.onHideModal}
                            onCancel={this.onCancel}
                        />
                    </ModalWindow>
                }
            </div>
        )
    }

    onChange = (e: any) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name === this.state.startDate.name) {
            const sd = moment(value);//start date
            const ed = moment();//end date

            const diff = Math.ceil(moment.duration(ed.diff(sd)).asDays());
            if (diff < -30 || diff > 30) {
                return;
            }
            onChange(this, name, value, () => {
                onChange(this, this.state.endDate.name, value, () => {
                    const { days } = this.calculateNumberOfDays();
                    onChange(this, this.state.noOfDays.name, days, () => {
                        const showDuration = this.showDuration();
                        setRequired(this, this.state.duration.name, showDuration);
                    })
                });
            });
        }
        else if (name === this.state.endDate.name) {
            onChange(this, name, value, () => {
                const { days } = this.calculateNumberOfDays();
                onChange(this, this.state.noOfDays.name, days, () => {
                    const showDuration = this.showDuration();
                    setRequired(this, this.state.duration.name, showDuration);
                })
            });
        } else if (name === this.state.addressTypeId.name && value === '2') {
            setRequired(this, this.state.remoteAddress.name, true, () => {
                onChange(this, name, value);
            })
        } else if (name === this.state.leaveTypeId.name) {
            const parsedValue = parseFloat(value);
            onChange(this, name, parsedValue, () => {
                const { days } = this.calculateNumberOfDays();
                onChange(this, this.state.noOfDays.name, days, () => {
                    const showDuration = this.showDuration();
                    setRequired(this, this.state.duration.name, showDuration);
                })
            });
        } else if (name === this.state.userCode.name) {
            onChange(this, name, value, () => {
                this.getUserLeaveDetail();
            });
        } else {
            onChange(this, name, value);
        }
    }

    getUserLeaveDetail = () => {
        const { userCode } = this.state;
        // const dt = new Date();
        // getLeaveSummary(userCode.value, dt.getFullYear()).then((res: any) => {
        //     this.setState({ leaveSummary: res.result.leaveTypeList })
        // });
        // getLeavesList(userCode.value, new Date().getFullYear()).then((res: any) => {
        //     this.setState({ leaveList: res.result });
        // });
        // getUserSummary(userCode.value).then((res: any) => {
        //     this.setState({ userSummary: res.result });
        // })
        getUserProxyLeaveDetail(userCode.value, new Date().getFullYear()).then((res: any) => {
            this.setState({
                userSummary: res.result.userSummary,
                leaveList: res.result.leaveList,
                leaveSummary: res.result.leaveSummary
            });
            //     this.setState({ userSummary: res.result });
            //     this.setState({ leaveList: res.result });
            //     this.setState({ leaveSummary: res.result.leaveTypeList })
        })
    }

    calculateNumberOfDays = () => {
        const { startDate, endDate, leaveTypeId, userSummary, holidays } = this.state;
        if (userSummary && holidays) {
            return this.getDateDiff(leaveTypeId.value, startDate.value, endDate.value, userSummary.weeklyOff);
        } else {
            return { days: 0, weekends: [], holidays: [] }
        }

    }

    getDateDiff = (leaveTypeId: string, startDate: any, endDate: any, weeklyOff: string) => {
        const cd = moment(startDate);//current date
        const sd = moment(startDate);//start date
        const ed = moment(endDate);//end date

        const dateArr = [];
        const diff = moment.duration(ed.diff(sd)).asDays() + 1;

        const weekendDayArr = weeklyOff.split(',').map(i => parseFloat(i));
        const holidayArr = this.state.holidays.map((item: any) => {
            return moment(item.date).format('YYYY-MM-DD');
        });

        for (let i = 0; i < diff; i++) {
            const dayType = cd.day();
            if (holidayArr.indexOf(cd.format('YYYY-MM-DD')) > -1) {
                dateArr.push({ type: 'HD', date: cd.format('YYYY-MM-DD') });
                cd.add(1, 'days');
                continue;
            } else if (weekendDayArr.indexOf(dayType) > -1) {
                dateArr.push({ type: 'WE', date: cd.format('YYYY-MM-DD') });
                cd.add(1, 'days');
                continue;
            }
            else {
                dateArr.push({ type: 'WD', date: cd.format('YYYY-MM-DD') });
                cd.add(1, 'days');
                continue;
            }
        }

        let leaveDays = [];
        if (leaveTypeId !== '') {
            const ltid = parseFloat(leaveTypeId);
            let weekends: any = [];
            let holidays: any = [];
            if (ltid === CONSTANT.static.leaveType.cl || ltid === CONSTANT.static.leaveType.rh) {
                leaveDays = dateArr.filter((i: any) => i.type === 'WD');
                weekends = dateArr.filter((i: any) => i.type === 'WE');
                holidays = dateArr.filter((i: any) => i.type === 'HD');
            } else {
                leaveDays = dateArr;
            }
            return { days: leaveDays.length, weekends, holidays }
        } else {
            return { days: dateArr.length, weekends: [], holidays: [] }
        }
    }

    checkLeaveClubbing = () => {
        const { startDate, endDate, leaveTypeId,
            userSummary, holidays } = this.state;
        const leaveList = this.state.leaveList.filter((i: any) => i.approved !== false);

        const leaveStartDate = moment(startDate.value, "YYYY-MM-DD");
        const leaveEndDate = moment(endDate.value, "YYYY-MM-DD");
        const parsedLeaveTypeId = parseFloat(leaveTypeId.value);
        // checking if the date has alrady been used while apply for some other leave
        for (let i = 0; i < leaveList.length; i++) {
            const sd = moment(leaveList[i].startDate, "YYYY-MM-DD");
            const ed = moment(leaveList[i].endDate, "YYYY-MM-DD");
            // omitting the optional third parameter, 'units'
            const isStartBetween = leaveStartDate.isBetween(sd, ed, 'days', '[]'); //false in this case
            const isEndBetween = leaveEndDate.isBetween(sd, ed, 'days', '[]'); //false in this case
            if (isStartBetween) {
                alert('Please select some different date range. You\'ve already applied for a leave in the given date range');
                return false;
            }

            if (isEndBetween) {
                alert('Please select some different date range. You\'ve already applied for a leave in the given date range');
                return false;
            }
        }

        // check for weekend and holidays in case of CL and RH
        if (leaveTypeId.value === CONSTANT.static.leaveType.cl || leaveTypeId.value === CONSTANT.static.leaveType.rh) {
            // checking if the leave has been applied on a weekend
            const sdWoIndex = userSummary.weeklyOff && userSummary.weeklyOff.indexOf(leaveStartDate.day());
            // const edWoIndex = userSummary.weeklyOff && userSummary.weeklyOff.indexOf(leaveEndDate.day());
            if (sdWoIndex > -1) {
                // if (sdWoIndex > -1 || edWoIndex > -1) {
                alert('Your leave is starting on a weekly off.');
                return false;
            }

            // checking if the leave are starting on a holiday
            for (let i = 0; i < holidays.length; i++) {
                if (holidays[i].date === startDate.value) {
                    // if (holidays[i].date === startDate.value || holidays[i].date === endDate.value) {
                    alert('Your leave is starting on a Holiday.');
                    return false;
                }
            }
        }

        // checking clubbing of valid leave types
        for (let i = 0; i < leaveList.length; i++) {
            const sd = moment(leaveList[i].startDate, "YYYY-MM-DD").add(-1, 'd').format('YYYY-MM-DD');
            const ed = moment(leaveList[i].endDate, "YYYY-MM-DD").add(1, 'd').format('YYYY-MM-DD');
            const lti = leaveList[i].leaveTypeId;

            // omitting the optional third parameter, 'units'
            if (sd === leaveEndDate.format('YYYY-MM-DD') || ed === leaveStartDate.format('YYYY-MM-DD')) {
                // el/nonel with cl
                if (lti === CONSTANT.static.leaveType.cl && parsedLeaveTypeId === CONSTANT.static.leaveType.el) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                } else if (lti === CONSTANT.static.leaveType.el && parsedLeaveTypeId === CONSTANT.static.leaveType.cl) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                }
                // el/nonel with cl
                else if (lti === CONSTANT.static.leaveType.rh && parsedLeaveTypeId === CONSTANT.static.leaveType.el) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                } else if (lti === CONSTANT.static.leaveType.el && parsedLeaveTypeId === CONSTANT.static.leaveType.rh) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                }
                // HPL with cl
                else if (lti === CONSTANT.static.leaveType.hpl && parsedLeaveTypeId === CONSTANT.static.leaveType.el) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                } else if (lti === CONSTANT.static.leaveType.el && parsedLeaveTypeId === CONSTANT.static.leaveType.hpl) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                }
                // CML with cl
                else if (lti === CONSTANT.static.leaveType.cml && parsedLeaveTypeId === CONSTANT.static.leaveType.el) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                } else if (lti === CONSTANT.static.leaveType.el && parsedLeaveTypeId === CONSTANT.static.leaveType.cml) {
                    alert('Clubbing of leaves are not allowed.');
                    return false;
                }
            }
        }
        return true;
    }

    onSubmit = (e: any) => {
        e.preventDefault();

        // const isSure = window.confirm('Are you sure, you want to submit the leave request');
        // if (!isSure) {
        //     return;
        // }
        if (validateForm(this) && this.validateLeaveBalance() && this.checkLeaveClubbing()) {
            this.setState({ showLoader: true });
            const st = this.state;
            const model = {
                assignedTo: st.assignedTo.value,
                leaveTypeId: st.leaveTypeId.value,
                startDate: st.startDate.value,
                endDate: st.endDate.value,
                noOfDays: st.noOfDays.value,
                duration: this.showDuration() ? parseFloat(st.duration.value) : undefined,
                addressTypeId: st.addressTypeId.value,
                remoteAddress: st.remoteAddress.value,
                reason: st.reason.value,
                userCode: st.userCode.value
            };

            addLeaveDetail(model).then((res: any) => {
                this.setState({ showLoader: false });
                if (res.status === CONSTANT.static.apiStatus.success) {
                    alert('Your leave request has been successfully posted.');
                    this.props.history.push(CONSTANT.component.userLeaveList.url);
                } else {
                    alert(res.error);
                }
            });
        }
    }

    showDuration = () => {
        const { noOfDays, leaveTypeId, startDate, endDate } = this.state;
        const showDuration = ((leaveTypeId.value === CONSTANT.static.leaveType.hpl || leaveTypeId.value === CONSTANT.static.leaveType.cml || leaveTypeId.value === CONSTANT.static.leaveType.cl) && noOfDays.value === 1)
        return showDuration;
    }

    validateLeaveBalance = () => {
        const { startDate, endDate, leaveTypeId, noOfDays, leaveSummary } = this.state;
        let ltid = leaveTypeId.value;
        let dayCount = noOfDays.value;
        let balance = 0;

        const sd = moment(startDate.value);//start date
        const ed = moment(endDate.value);//end date
        const diff = moment.duration(ed.diff(sd)).asDays() + 1;

        if (diff <= 0) {
            alert('To date cannot be greater than From date.');
            return false;
        }
        if (diff > 30) {
            alert('Leave of more than 30 days are not allowed.');
            return false;
        }


        if (ltid === CONSTANT.static.leaveType.cml) {
            ltid = CONSTANT.static.leaveType.hpl;
            dayCount = dayCount * 2;
        }
        if (ltid === CONSTANT.static.leaveType.el) {
            const elBalance = leaveSummary.filter((j: any) => j.code === CONSTANT.static.leaveType.el);
            const nonelBalance = leaveSummary.filter((j: any) => j.code === CONSTANT.static.leaveType.nonel);
            balance = (elBalance[0].total - elBalance[0].used - elBalance[0].pending) + (nonelBalance[0].total - nonelBalance[0].used - nonelBalance[0].pending);
        } else {
            const leaveBalance = leaveSummary.filter((j: any) => j.code === ltid);
            balance = leaveBalance[0].total - leaveBalance[0].used - leaveBalance[0].pending;
        }

        if (balance < dayCount) {
            alert(`Sorry, You dont have sufficient balance for leave application`);
            return false;
        }

        return true;
    }

    onShowModal = () => {
        this.setState({ showModal: true });
    }

    onHideModal = () => {
        this.setState({ showModal: false });
    }

    onCancel = () => {
        this.props.history.push(CONSTANT.component.userLeaveList.url);
    }

    onCompare = function (a: any, b: any) {
        let comparison = 0;
        if (a.name > b.name) {
            comparison = 1;
        } else if (a.name < b.name) {
            comparison = -1;
        }
        return comparison;
    }
}

export default ComponentName;